var map = {
	"./de/gotoTOPbg.png": "DZLC",
	"./en/gotoTOPbg.png": "0O1b",
	"./es/gotoTOPbg.png": "NrYV",
	"./fr/gotoTOPbg.png": "OAIw",
	"./ja/gotoTOPbg.png": "XmBz",
	"./ko/gotoTOPbg.png": "ej0l",
	"./pt/gotoTOPbg.png": "9TYk",
	"./ru/gotoTOPbg.png": "+TK4",
	"./tc/gotoTOPbg.png": "B4o2",
	"./th/gotoTOPbg.png": "qLv9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UapW";